import { ArrowUpRight, Clock, AlertTriangle, Banknote } from 'lucide-react';
import { formatCurrencyAmount, formatNumberValue, formatPercentageValue } from '../../../utils/miscFunctions';
import DashboardDatePickers, { SelectedDateRange } from '../../../components/dashboard/date-range-selector/datePicker';

interface IVehicleVerificationOverviewMetrics {
  data: {
    completedVerifications: number;
    completionRate: number;
    pendingVerifications: number;
    coverTypeDistribution: any
    totalVerifications: number
  }
  setSelectedDateRange: (data: SelectedDateRange) => void
}


const VehicleVerificationOverviewPanel = ({ data, setSelectedDateRange }: IVehicleVerificationOverviewMetrics) => {

  // Calculate percentages safely (avoid division by zero)
  const totalCount = data?.totalVerifications || 1;
  const completedPercentage = (data?.completedVerifications / totalCount) * 100;

  const statistics = [
    {
      title: 'Total Vehicle Inspections',
      count: data?.totalVerifications,
      amount: data?.totalVerifications,
      borderColor: 'border-blue-500',
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-600',
      icon: <Banknote className="h-6 w-6 text-blue-600" />
    },
    {
      title: 'Completed Inspections',
      count: data?.completedVerifications,
      amount: data?.completedVerifications,
      borderColor: 'border-green-500',
      bgColor: 'bg-green-100',
      textColor: 'text-green-600',
      icon: <ArrowUpRight className="h-6 w-6 text-green-600" />
    },
    {
      title: 'Pending Inspections',
      count: data?.pendingVerifications,
      amount: data?.pendingVerifications,
      borderColor: 'border-yellow-500',
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-600',
      icon: <Clock className="h-6 w-6 text-yellow-600" />
    },
  ];

  return (
    <div className="bg-white dark:bg-darkBg rounded-lg  p-6">
      {/* <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-gray-900">Overview</h2>
        <DashboardDatePickers
          onSubmit={(data: SelectedDateRange) => {
            setSelectedDateRange(data);
          }}
        />
      </div> */}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-2">
        {statistics.map((statistic) => (
          <div key={statistic.title} className={`bg-white dark:bg-darkBg  rounded-lg p-4 shadow border-l-4 dark:border-t dark:border-b dark:border-r dark:border-t-darkBg-border dark:border-b-darkBg-border dark:border-r-darkBg-border  ${statistic.borderColor}`}>
            <div className="flex flex-wrap  items-start justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500 dark:text-darkBg-mainText">{statistic.title}</p>
                <p className="text-2xl font-bold text-gray-800 dark:text-darkBg-mainText">
                  {formatNumberValue(statistic.count)}
                </p>
                <div className="text-xs text-gray-500 mt-1">
                  {statistic.count} {statistic.count === 1 ? 'inspection' : 'inspections'} • {
                    statistic.title === 'Total Vehicle Inspections'
                      ? ''
                      : `${formatPercentageValue((statistic.amount / totalCount) * 100)} of total`
                  }
                </div>
              </div>
              <div className={`rounded-full ${statistic.bgColor} p-3`}>
                {statistic.icon}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-between items-center">
        <div className="text-sm font-medium text-gray-700 dark:text-darkBg-mainText">
          <span className="text-green-600">{formatPercentageValue(completedPercentage)}</span> of inspections already completed
        </div>
      </div>
    </div>
  );
};

export default VehicleVerificationOverviewPanel;
